import * as React from "react";
import {
  Box,
  Stack,
  Typography,
  Avatar,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import { Colors } from "../../utils/Colors";

export default function DoctorHeader() {
  return (
    <Box
      sx={{
        bgcolor: Colors.bg.paper,
        border: `1px solid ${Colors.border.light}`,
        borderRadius: 4,
        p: 2.2,
        boxShadow: Colors.shadow.brand,
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
        spacing={2}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              color: Colors.text.header,
              lineHeight: 1.1,
            }}
          >
            Doctor Dashboard
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: Colors.text.muted,
              mt: 0.7,
            }}
          >
            Welcome back. Here is today’s patient and appointment overview.
          </Typography>
        </Box>

        <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
          <TextField
            size="small"
            placeholder="Search patient, UHID, appointment..."
            sx={{
              minWidth: { xs: 220, md: 320 },
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                bgcolor: Colors.bg.app,
                color: Colors.text.body,
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: Colors.border.input,
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRoundedIcon sx={{ color: Colors.text.icon }} />
                </InputAdornment>
              ),
            }}
          />

          <IconButton
            sx={{
              border: `1px solid ${Colors.border.light}`,
              bgcolor: Colors.bg.app,
            }}
          >
            <NotificationsNoneRoundedIcon sx={{ color: Colors.text.icon }} />
          </IconButton>

          <Stack direction="row" spacing={1.2} alignItems="center">
            <Avatar sx={{ bgcolor: Colors.brand.primary }}>
              D
            </Avatar>
            <Box>
              <Typography
                variant="body2"
                sx={{ fontWeight: 700, color: Colors.text.title }}
              >
                Dr. Sharma
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: Colors.text.sub }}
              >
                Senior Consultant
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}